import React, { useEffect, useMemo, useRef } from "react";
import Layout from "@components/layout";
import styles from "./styles.module.css";
import SEO from "@components/seo";
import { Link, graphql } from "gatsby";
import Intro from "./intro";
import Details from "./details";
import Includes from "./includes";
import Skills from "./skills";
import Audience from "./audience";
import Scheme from "./scheme";
import Program from "./program";
import Team from "./team";
import PriceList from "./priceList";
import Footer from "./footer";
import SchemeDesktop from "./schemeDesktop";
import ProgramDesktop from "./programDesktop";
import Logo from "./icons/logo.png";
import NoSSR from "../../components/utils/NoSSR";
import Consultation from "./consultation";
import Career from "./career";
import TwitterReviews from "../../components/twitterReviews";

const CoursePost = ({ data, pageContext, path }) => {
  const {
    title,
    tutor,
    video,
    priceOld,
    includes,
    desc,
    deadline,
    skills,
    audience,
    background,
    details,
    program,
    teacher,
    slug,
    scheme,
    order,
  } = data.contentfulCourse;

  const { promocodes } = pageContext;
  const reviews = data.allContentfulReviews.edges;
  const bootcampToReviews = data.allContentfulBootcampToReviews.edges;
  useEffect(() => {
    var currentUtm = window.location.search.substr(1).split("&");
    if (currentUtm !== "") {
      localStorage.setItem("currentUtm", currentUtm);
    }
  });

  return (
    <div style={{ overflow: "hidden" }}>
      <Layout>
        <SEO
          title={`Курсы по web3-разработке: ${title}`}
          description={desc.desc}
        />
        <NoSSR>
          <div className={styles.mobileDisplayBlock}>
            <Link to="/#courses">
              <div className={styles.krissKross}></div>
            </Link>

            <Intro
              title={title}
              tutor={tutor}
              video={video}
              priceOld={priceOld}
              slug={slug}
              deadline={deadline}
              order={order}
            />

            <Details
              priceOld={priceOld}
              desc={desc.desc}
              details={details}
              title={title}
              slug={slug}
              deadline={deadline}
              video={video}
              order={order}
            />

            {includes && <Includes includes={includes} />}
            {skills && <Skills skills={skills} />}
            {audience && <Audience audience={audience} />}
            {scheme && <Scheme scheme={scheme} />}
            {program && <Program program={program} />}
            <div className={styles.onMobile}>
              <Consultation title={title} />
            </div>
            <Career />
            {teacher && <Team teacher={teacher} />}
            <TwitterReviews
              autoScrollEnabled={false}
              tweetsData={reviews}
              bootcampToReviews={bootcampToReviews}
              content={path.slice(1, path.length)}
              bgColor="#f1eeee"
              isBacklight={false}
            />
            <PriceList
              priceOld={priceOld}
              title={title}
              slug={slug}
              deadline={deadline}
              promocodes={promocodes}
            />
            <Footer />
          </div>

          <div className={styles.desktopDisplayBlock}>
            <div
              className={styles.fixedContainer}
              style={{ backgroundImage: `url(${background.file.url})` }}
            >
              <Details
                priceOld={priceOld}
                desc={desc.desc}
                details={details}
                title={title}
                slug={slug}
                deadline={deadline}
                video={video}
                order={order}
              />
            </div>
            <div className={styles.container}>
              <div className={styles.width}>
                <Intro
                  title={title}
                  tutor={tutor}
                  video={video}
                  priceOld={priceOld}
                  slug={slug}
                  order={order}
                />
                {includes && <Includes includes={includes} />}
                {skills && <Skills skills={skills} />}
                {audience && <Audience audience={audience} />}
                {scheme && <SchemeDesktop scheme={scheme} />}
                {program && <ProgramDesktop program={program} />}
              </div>
              <Career />

              {teacher && <Team teacher={teacher} />}

              <TwitterReviews
                tweetsData={reviews}
                autoScrollEnabled={false}
                bootcampToReviews={bootcampToReviews}
                content={path.slice(1, path.length)}
                bgColor="#f1eeee"
                isBacklight={false}
              />
              <div id="price">
                <PriceList
                  priceOld={priceOld}
                  title={title}
                  slug={slug}
                  deadline={deadline}
                  promocodes={promocodes}
                />
              </div>
              <Footer />
            </div>
            <Link to={"/#bootcamps"}>
              <div
                className={styles.animatedBlock}
                style={{ backgroundImage: `url(${Logo})` }}
              ></div>
            </Link>
          </div>
        </NoSSR>
      </Layout>
    </div>
  );
};
export default CoursePost;

export const pageQuery = graphql`
  query($slug: String) {
    contentfulCourse(slug: { eq: $slug }) {
      title
      tutor
      order
      video
      slug
      logoForProfession {
        file {
          url
        }
      }
      background {
        file {
          url
        }
      }
      deadline
      priceOld
      includes {
        text
      }
      skills {
        text
      }
      audience {
        text
      }

      details
      desc {
        desc
      }
      teacher {
        role
        name
        company
        about {
          about
        }
        photo {
          file {
            url
          }
        }
      }
      program {
        title
        text
      }
      scheme {
        svg
        desc
        title
      }
    }
    allContentfulReviews {
      edges {
        node {
          nick
          name
          link
          likes
          text {
            content {
              content {
                value
              }
            }
          }
          date
          avatar {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulBootcampToReviews {
      edges {
        node {
          bootcamp
          reviews {
            content {
              content {
                value
              }
            }
          }
        }
      }
    }
  }
`;
